import { FooterActionBar } from "@/components/commons/FooterActionBar";
import { ContactTypeForm } from "@/features/contact-type/components/ContactTypeForm";
import { contactMenu } from "@/features/contact-type/constants/contactMenu";
import { AppRoutes } from "@/routes/config";
import { getDynamicRoute } from "@/utils/url";
import { Stack } from "@mui/material";
import { FC, useMemo, useRef, useState } from "react";
import { matchRoutes, useLocation, useParams } from "react-router-dom";

type TContactTypeCreatePageProps = {};

export const ContactTypeCreatePage: FC<TContactTypeCreatePageProps> = () => {
  const { id } = useParams();
  const formRef = useRef<{ submit: () => void }>(null);
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();

  const isExtraUrlActive = useMemo(() => {
    return contactMenu.some(({ extraUrls }) => extraUrls?.some((extraUrl) => matchRoutes([{ path: extraUrl }], pathname) !== null));
  }, [pathname]);

  const backUrl = useMemo(() => {
    if (isExtraUrlActive) {
      const activeMenu = contactMenu.find(({ extraUrls }) => extraUrls?.some((extraUrl) => matchRoutes([{ path: extraUrl }], pathname) !== null));
      return activeMenu ? getDynamicRoute(activeMenu.url, { id }) : AppRoutes.duringContractList;
    }
    return AppRoutes.duringContractList;
  }, [isExtraUrlActive, pathname, id]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await Promise.resolve(formRef.current?.submit());
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack gap={4}>
      <ContactTypeForm ref={formRef} />
      <FooterActionBar title="保存" onSubmit={handleSubmit} isLoading={loading} backUrl={backUrl} />
    </Stack>
  );
};
